<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Orçamentos</span>
        <h3 class="page-title" v-if="quotation.id">Editar</h3>
        <h3 class="page-title" v-else>Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row class="h-100">
      <d-col lg="12" class="d-flex flex-column flex-fill">
        <steps :steps="quotationSteps(quotation)" :quotationId="$route.params.quotationId"/>
        <router-view></router-view>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import Steps from '../components/Steps/index.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/QuotationModel';

export default {
  name: 'quotation-create',
  components: {
    Steps,
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    quotation() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        return quotation;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getQuotation',
    ]),
    getModel(id) {
      this.setToggle({ type: 'progress', bool: true });
      this.getQuotation(id)
        .then(response => {
          const step = Object.values(response.steps.step).reverse().filter(item => item.completed)[0];
          const routeName = [
            'admin-quotation-customer',
            'admin-quotation-service',
            'admin-quotation-edit',
            'admin-quotation-project',
            'admin-quotation-deal',
            'admin-quotation-installation',
            'admin-quotation-file',
            'admin-quotation-approved',
          ];
          const index = step.step > 5 ? 7 : step.step;
          this.$router.push({ name: `${routeName[index]}`, params: { quotationId: id } });
          Events.$emit(_LOAD_MODEL_, response);
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    quotationSteps(quotation) {
      if (quotation.steps.step) {
        return quotation.steps.step;
      }
      return null;
    },
  },
  mounted() {
    const { quotationId } = this.$route.params;
    const id = parseInt(quotationId, Number);
    if (id) {
      return this.getModel(id);
    }
    return this.$router.push({ name: 'admin-quotation-customer', params: { quotationId } });
  },
  created() {
    this.$store.commit('setQuotation', MODEL);
    Events.$emit(_LOAD_MODEL_, MODEL);
    Events.$emit('sidebarVisible', false);
  },
};
</script>

<style lang="scss" scoped>
</style>
